// src/components/modules/ModuleIndex.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import ModuleList from "./ModuleList";
import ModuleForm from "./ModuleForm";

const ModuleIndex: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ModuleList />} />
      <Route path="/create" element={<ModuleForm />} />
      <Route path="/edit/:id" element={<ModuleForm isEditMode={true} />} />
    </Routes>
  );
};

export default ModuleIndex;